import ErrorScreen from "./screens/error";
import LockScreen from "./screens/lock";
import LoginScreen from "./screens/login";
import MainScreen from "./screens/main";
import { Routes, Route, Navigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const PrivateRoute = (props) => {
    const { children } = props;
    const token = localStorage.getItem("token");
    return token ? (
      <>{children}</>
    ) : (
      <Navigate replace={true} to={{ pathname: "/" }} />
    );
  };

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<LoginScreen />} />
        <Route
          path="/e/:route"
          element={
            <PrivateRoute>
              <MainScreen />
            </PrivateRoute>
          }
        />
        <Route path="/error" element={<ErrorScreen />} />
        <Route path="/lock" element={<LockScreen />} />
        <Route path="*" element={<ErrorScreen />} />
      </Routes>
    </div>
  );
}

export default App;
